<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">
      <el-form-item :label="$t('lang.序号')" prop="number">
        <el-select v-model="formData.number" :placeholder="$t('lang.请选择')">
          <el-option v-for="i in 30" :key="i + '_tag'" :label="i" :value="i"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.标签')" prop="tagCode">
        <el-select v-model="formData.tagCode" :placeholder="$t('lang.请选择')">
          <el-option v-for="tag in recipeTagList" :key="tag.recipeTagCode" :label="tag.name" :value="tag.recipeTagCode"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>

import {recipeTagList} from "../../js/common";

export default {
  name: "LockScreenAdsEdit",
  components: {},
  data() {
    return {
      api: {
        update: this.$api.hotTag.update,
        detail: this.$api.hotTag.detail,
      },
      formErrorMsg: {name: ''},
      formData: {
        code: '',
        number: '',
        tagCode: '',
        brandOwnerCode: this.$store.state.userInfo.brandOwnerCode,
      },
      recipeTagList: []
    }
  },
  computed: {
    rules() {
      return {
        number: [
          {required: true, message: this.$t('lang.序号不能为空'), trigger: 'blur'}
        ],
        tagCode: [
          {required: true, message: this.$t('lang.标签不能为空'), trigger: 'change'}
        ],

      }
    }
  },
  methods: {
    handleSubmit(form) {

      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          vm.$http.post(vm.api.update, this.$qs.stringify(this.formData)).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              vm.$message({
                type: "error",
                message: resp.data.desc
              });
            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    },
    handleReset(form) {
      this.$refs[form].resetFields();
    }
  },

  async created() {

    let vm = this;
    this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
      for (let key in resp.data.data) {
        for (let fKey in vm.formData) {
          vm.formData[fKey] = resp.data.data[key][fKey]

          if (fKey === 'birthday' && vm.formData[fKey]) {
            vm.formData['birthday'] = vm.$moment(vm.formData[fKey]).format('YYYY-MM-DD');
          }

        }
      }
    });

    this.recipeTagList = await recipeTagList(this);

  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}
</style>
